// extracted by mini-css-extract-plugin
export default {"table":"OrderTable_table__lm-UR","totalPrice":"OrderTable_totalPrice__qoqQw"};